import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse, userLoaders} from '../../../../domain';
import {HttpPromiseState, StringControl, validators} from '../../../../lib/helpers';

export class SetPasswordStore {
  password: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly id: number) {
    makeObservable(this);
    this.password = new StringControl('', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    this.password.markTouched();
    if (this.password.invalid)
      return;
    if (this.save?.isPending === true)
      return;
    this.save = userLoaders.setPassword(this.id, this.password.value);
  }
}
